import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import NotFound from "../../NotFound/NotFound";
import RegistrationsList from "./registrations/list/RegistrationsList";
import UserRegistration from "./registrations/registration/UserRegistration";

const rp = RouterPath.admin;

function Admin() {

    return (<>
            <Switch>
                <Route exact path={rp.ADMIN_REGISTRATIONS}>
                    <Redirect to={rp.ADMIN_REGISTRATIONS_LIST} push={false}/>
                </Route>
                <Route path={rp.ADMIN_REGISTRATIONS_LIST} component={RegistrationsList}/>
                <Route path={rp.ADMIN_REGISTRATION_ID} component={UserRegistration}/>
                <Route component={NotFound}/>
            </Switch>
        </>
    )
}

export default Admin;

